<script setup lang="ts">
/**
 * /login while signed out (owner 19 ต.ค. 69): the owner's switch "บัญชีให้ผู้ตรวจ Meta เข้าทดสอบ" is on → the Meta reviewer's
 * sign-in form (ReviewerSignIn.vue); off — or the switch cannot be read — → the normal POS screen (SignedOut.vue), so
 * nothing hints at a reviewer account. Asks GET /auth/reviewer/status once; a thin top bar while it waits.
 */
import { onMounted, ref } from 'vue'
import { reviewerPublicApi } from '../api/reviewer'
import type { SignedOutReason } from '../api/session'
import ReviewerSignIn from './ReviewerSignIn.vue'
import SignedOut from './SignedOut.vue'

defineProps<{ reason: SignedOutReason; failed?: boolean }>()
const emit = defineEmits<{ retry: []; signedIn: [] }>()

const open = ref<boolean | null>(null)

onMounted(async () => {
  try {
    open.value = await reviewerPublicApi().status()
  } catch {
    open.value = false
  }
})
</script>

<template>
  <ReviewerSignIn v-if="open" :reason="reason" @signed-in="emit('signedIn')" @closed="open = false" />
  <SignedOut v-else-if="open === false" :reason="reason" :failed="failed" @retry="emit('retry')" />
  <div v-else class="boot" role="status" aria-label="กำลังโหลด"><span></span></div>
</template>

<style scoped>
.boot {
  position: fixed;
  inset: 0 0 auto;
  height: 3px;
  overflow: hidden;
}
.boot span {
  display: block;
  width: 30%;
  height: 100%;
  background: var(--ac);
  animation: boot 1.1s ease-in-out infinite;
}
@keyframes boot {
  from {
    transform: translateX(-100%);
  }
  to {
    transform: translateX(340%);
  }
}
</style>
